var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFacebookIco = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26.94 26.77",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook_ico"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook_ico-2",
    "data-name": "facebook ico"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_138",
    "data-name": "Trazado 138",
    d: "M26.94,13.47a13.47,13.47,0,1,0-15.58,13.3V17.36H8v-3.9h3.43v-3c0-3.37,2-5.25,5.08-5.25a17.73,17.73,0,0,1,3,.29v3.3H17.75a2,2,0,0,0-2.21,1.71,2.8,2.8,0,0,0,0,.41v2.53h3.75l-.6,3.89H15.55v9.42a13.46,13.46,0,0,0,11.39-13.3"
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFacebookIco, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/facebook_ico.549adc72.svg";
export { ForwardRef as ReactComponent };